var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ConnectionBox',{attrs:{"displayName":"osu!","color":"#F06EA8","icon":"osu.svg","data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }